import { useTranslation } from "react-i18next";

import { ChevronRight, SlPhoneRose } from "@/assets/icons/icons.tsx";
import { ProductCard } from "@/components/Layout/BaseLayouts/ProductCard/ProductCard";
import { ProductCardFooterItem } from "@/components/Layout/BaseLayouts/ProductCard/ProductCardFooterItem";
import { getItemizedBillsRedirectLink } from "@/utils/itemizedBillLink.ts";

/**
 * Promotes the itemized-bills overview (EVN) on the Cockpit dashboard.
 * Gated behind CockpitDashboard's `showEVN` — see there for visibility logic.
 */
export const EVNCard = () => {
  const { t } = useTranslation("portal");

  return (
    <ProductCard
      dataTestid="evn-card"
      header={
        <div className="flex h-full w-full flex-col items-start gap-3 pt-4">
          <SlPhoneRose className="size-16 shrink-0" />
          <p className="w-full text-headline-md font-semibold leading-sm text-foreground-primary">
            {t("layout.tiles.evnCard.title")}
          </p>
          <p className="w-full text-body-lg font-semibold leading-md text-foreground-primary">
            {t("layout.tiles.evnCard.text")}
          </p>
        </div>
      }
      footer={
        <ProductCardFooterItem
          variant="button"
          label={t("layout.tiles.evnCard.button")}
          icon={<ChevronRight />}
          onClick={() =>
            window.open(getItemizedBillsRedirectLink(), "_blank", "noreferrer")
          }
        />
      }
    />
  );
};
